export const specialities = [
	{ label: "Cats", value: "FELINE" },
	{ label: "Dogs", value: "CANINE" },
	{ label: "Bird", value: "AVIAN" },
	{ label: "Bunny", value: "LAGOMORPH" },
	{ label: "Chicken", value: "CHICKEN" },
	{ label: "Ferrets", value: "MUSTELIDAE" },
	{ label: "Guinea pig", value: "GUINEA_PIGS" },
	{ label: "Hamster", value: "HAMSTERS" },
	{ label: "Rat", value: "RODENT" },
	{ label: "Reptile", value: "REPTILIAN" },
	{ label: "Others", value: "OTHERS" },
];

export const petTypes = [
	{ label: "Cat", value: "FELINE" },
	{ label: "Dog", value: "CANINE" },
	{ label: "Bird", value: "AVIAN" },
	{ label: "Bunny", value: "LAGOMORPH" },
	{ label: "Chicken", value: "CHICKEN" },
	{ label: "Ferrets", value: "MUSTELIDAE" },
	{ label: "Guinea pig", value: "GUINEA_PIGS" },
	{ label: "Hamster", value: "HAMSTERS" },
	{ label: "Rat", value: "RODENT" },
	{ label: "Reptile", value: "REPTILIAN" },
];

export const rhapsodyPetTypes = [
	{ label: "Cat", value: "FELINE" },
	{ label: "Dog", value: "CANINE" },
	{ label: "Horse", value: "EQUINE" },
	{ label: "Cow", value: "BOVINE" },
	{ label: "Goat", value: "CAPRINE" },
	{ label: "Sheep", value: "OVINE" },
	{ label: "Pig", value: "PORCINE" },
	{ label: "Chicken", value: "CHICKEN" },
	{ label: "Llamas", value: "LLAMAS" },
	{ label: "Alpaca", value: "ALPACAS" },
	{ label: "Bird", value: "AVIAN" },
	{ label: "Fish", value: "AQUATIC" },
	{ label: "Reptiles", value: "REPTILIAN" },
	{ label: "Bunnies", value: "LAGOMORPH" },
	{ label: "Hamsters", value: "HAMSTERS" },
	{ label: "Rats", value: "RODENT" },
	{ label: "Guinea pig", value: "GUINEA_PIGS" },
	{ label: "Hedgehogs", value: "HEDGEHOGS" },
	{ label: "Amphibian", value: "AMPHIBIAN" },
	{ label: "Primate", value: "PRIMATE" },
	{ label: "Marsupial", value: "MARSUPIAL" },
	{ label: "Ferret", value: "MUSTELIDAE" },
	{ label: "Other", value: "OTHERS" },
];

export const getVetSpecialtyFromPet = (pet?: { type?: string; breed?: string } | null): string => {
	const petType = pet?.type === "Other" ? pet?.breed : pet?.type;
	if (!petType) {
		return "OTHERS";
	}

	const normalized = String(petType).toLowerCase();
	const match =
		specialities.find((item) => item.value === petType) ||
		specialities.find((item) => item.label.toLowerCase() === normalized) ||
		petTypes.find((item) => item.value === petType || item.label.toLowerCase() === normalized) ||
		rhapsodyPetTypes.find((item) => item.value === petType || item.label.toLowerCase() === normalized);

	return match?.value || petType;
};
